module.exports = __webpack_public_path__ + "img/bg_avatar_female_23.64329bd4.png";